export default "/react/logoChotam-a4d5c787.png";